export default __webpack_public_path__ + "static/showroom-fabric-91b0bc58d6bf7091d90817f1f07afc3c.png";